<h2 class="{{addStyle}} primary-text ">{{childHeadingTitle}}</h2>